var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages.length)?_c('div',{staticClass:"alert",class:_vm.alertClass,attrs:{"role":"alert"}},[_c('ul',{staticClass:"mb-0"},_vm._l((_vm.messages),function(message){return _c('li',{key:message},[_vm._v(_vm._s(message))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }